import { getApi } from 'api';
import { AxiosResponse } from 'axios';
import {
  AffectedCompanyModel,
  CompaniesWithExceptionsFilter,
  CompanyExceptionModel,
  PreviewAffectedCompaniesFilter,
  UpdateWageIndexationModel,
  WageIndexationFilterProps,
} from 'modules/payroll-settings/wage-indexation/types';
import { IMinimumWage } from 'types/minimum-wage';

export const getCurrentWageIndexationDataRequest = async (
  props: WageIndexationFilterProps,
): Promise<IMinimumWage[]> => {
  const response: AxiosResponse<IMinimumWage[]> = await getApi().post('WageIndexation/GetCurrent', props);
  return response.data;
};

export const getWageIndexationDataPreviewRequest = async (
  props: WageIndexationFilterProps,
): Promise<IMinimumWage[]> => {
  const response: AxiosResponse<IMinimumWage[]> = await getApi().post('WageIndexation/GetUpdated', props);
  return response.data;
};

export const updateWageIndexationDataRequest = async (props: UpdateWageIndexationModel): Promise<void> => {
  await getApi().post('WageIndexation/Update', props);
};

export const getCompaniesWithExceptionsRequest = async (
  props: CompaniesWithExceptionsFilter,
): Promise<CompanyExceptionModel[]> => {
  const response: AxiosResponse<CompanyExceptionModel[]> = await getApi().post(
    'WageIndexation/GetCompaniesWithExceptionsToIndex',
    props,
  );

  return response.data;
};

export const previewAffectedCompaniesRequest = async (props: {
  filter: PreviewAffectedCompaniesFilter;
}): Promise<AffectedCompanyModel[]> => {
  const response: AxiosResponse<AffectedCompanyModel[]> = await getApi().post(
    'WageIndexation/PreviewAllIndexedCompanies',
    props.filter,
  );

  return response.data;
};
